





import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 */
@Component({})
export default class JdsFilterBar extends Vue {
    // todo: activeinject "sidebar" state for when used as a sidebar
}
